// only for mobile view in single page registration with job id
// sticky button at the bottom to open registration or login and apply
import { createJobApplyUrl } from "@/helpers/jobs";
import { Button } from "@monsterindia/global-ui-components";
import { useSearchParams } from "next/navigation";
import React from "react";

type ActionButtonsProps = {
  handleClick: () => void;
};

const ActionButtons: React.FC<ActionButtonsProps> = ({ handleClick }) => {
  const redirectToLogin = () => {
    const searchParams = useSearchParams();
    let detailPageUrl = createJobApplyUrl(searchParams);
    if (searchParams.toString()) {
      detailPageUrl += `&${searchParams.toString()}`;
    }
    window.location.href =
      "/rio/login/seeker?return_url=" + encodeURIComponent(detailPageUrl);
  };

  return (
    <div className="shadow-top flex w-full items-center justify-center gap-4 px-4 py-2">
      <Button
        modifier="secondary"
        label="Login & apply"
        size="lg"
        className="w-full"
        onClick={redirectToLogin}
      />
      <Button
        modifier="primary"
        label="Register & apply"
        size="lg"
        className="w-full"
        onClick={handleClick}
      />
    </div>
  );
};

export default ActionButtons;
